import { useMutation } from 'react-apollo';

import {
  accountLogin as accountLoginMutation,
  accountLoginByPhone as accountLoginByPhoneMutation,
  phoneVerificationRequest as phoneVerificationRequestMutation,
} from '../../../../graphql/mutations/account';

const useSlideshowOnboarding = () => {
  const [accountLogin] = useMutation(accountLoginMutation);
  const [accountLoginByPhone] = useMutation(accountLoginByPhoneMutation);
  const [phoneVerificationRequest] = useMutation(
    phoneVerificationRequestMutation,
  );

  const onAccountLogin = async (email, password) => {
    await accountLogin({
      variables: {
        input: { email, password },
      },
    });
  };

  const onAccountLoginByPhone = async (phoneNumber, code) => {
    await accountLoginByPhone({
      variables: {
        input: {
          phone_number: phoneNumber,
          phone_verification_code: code,
          set_cookie: true,
        },
      },
    });
  };

  const onPhoneVerificationRequest = async phoneNumber => {
    await phoneVerificationRequest({
      variables: {
        input: {
          phone_number: phoneNumber,
          platform: 'WEB',
        },
      },
    });
  };

  return {
    onAccountLogin,
    onAccountLoginByPhone,
    onPhoneVerificationRequest,
  };
};

export default useSlideshowOnboarding;
